import { render, staticRenderFns } from "./LessonEditorDialog.vue?vue&type=template&id=02b208b2"
import script from "./LessonEditorDialog.vue?vue&type=script&lang=js"
export * from "./LessonEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports